@let headerExtraClasses = headerExtraClasses$ | async;
@let headerLevel = headerLevel$ | async;
@let icons = icons$ | async;
@let title = title$ | async;

<article [ngClass]="styleClasses$ | async" #articleWrapper [id]="mappedSegment | decodeURI: true">
  @if (!hideMediaContentImage && (mappedImage$ | async)) {
    <div class="image-container">
      <fin-content-image class="block image-height mr-medium-b" [scale]="scaleImage" [imageData$]="mappedImage$" />
    </div>
  }
  @if (title) {
    @if (icons?.length) {
      <div class="flex icon-with-heading mr-xsmall-b">
        @for (icon of icons; track icon.name) {
          <fcom-icon
            [category]="icon.category ?? IconLibrary.SVG_LIBRARY"
            [name]="icon.name"
            class="icon-large ms-small-r"
          />
        }
        @if (headerLevel) {
          <fcom-heading-tag [extraClasses]="headerExtraClasses" [level]="headerLevel">
            {{ title }}
          </fcom-heading-tag>
        } @else {
          <span class="bold-type">{{ title }}</span>
        }
      </div>
    } @else {
      <fcom-heading-tag [extraClasses]="headerExtraClasses" [level]="headerLevel || DEFAULT_HEADER_LEVEL">
        {{ title }}
      </fcom-heading-tag>
    }
  }
  <div #contentWrapper [innerHTML]="mappedContent$ | async | finSafe: 'html'"></div>
</article>
